import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaMapMarkerAlt,
  FaBirthdayCake,
  FaRulerVertical,
  FaBriefcase
} from "react-icons/fa";
import "animate.css";
import { baseUrl } from "../App";

function ViewUsers() {

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [sentInterests, setSentInterests] = useState([]);

  // 🔎 Filter states
  const [gender, setGender] = useState("");
  const [city, setCity] = useState("");
  const [minAge, setMinAge] = useState("");
  const [qualification, setQualification] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    fetchUsers();
    fetchCurrentUser();
    fetchSentInterests();
  }, []);

  // 🔹 Fetch Active Users
  const fetchUsers = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      const res = await axios.get(`${baseUrl}/active`);

      const usersExcludingSelf = res.data.filter(
        user => user.id !== parseInt(userId)
      );

      setUsers(usersExcludingSelf);
      setFilteredUsers(usersExcludingSelf);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Fetch Current User
  const fetchCurrentUser = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      const res = await axios.get(`${baseUrl}/get/${userId}`);
      setCurrentUser(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Fetch Already Sent Interests
  const fetchSentInterests = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      const res = await axios.get(
        `${baseUrl}/interest/requester/${userId}`
      );

      const requestedIds = res.data.map(log => log.requested?.id);
      setSentInterests(requestedIds);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔥 Apply Filters
  const applyFilters = () => {
    let result = users;

    if (gender) {
      result = result.filter(
        (u) => u.gender?.toLowerCase() === gender.toLowerCase()
      );
    }

    if (city) {
      result = result.filter(
        (u) => u.city?.toLowerCase() === city.toLowerCase()
      );
    }

    if (minAge) {
      result = result.filter(
        (u) => u.age >= parseInt(minAge)
      );
    }

    if (qualification) {
      result = result.filter(
        (u) => u.qualification?.toLowerCase().includes(qualification.toLowerCase())
      );
    }

    if (searchKeyword) {
      const keyword = searchKeyword.toLowerCase();
      result = result.filter(
        (u) => u.about_me?.toLowerCase().includes(keyword) || 
               u.work_location?.toLowerCase().includes(keyword) ||
               u.qualification?.toLowerCase().includes(keyword)
      );
    }

    setFilteredUsers(result);
  };

  // ❤️ Send Interest
const handleInterested = async (requestedId) => {
  try {
    const requesterId = sessionStorage.getItem("userId");

    await axios.post(
      `${baseUrl}/interest?requesterId=${requesterId}&requestedId=${requestedId}`
    );

    alert("Interest Sent Successfully ❤️");

  } catch (error) {
    alert(error.response?.data || "Failed ❌");
  }
};

  // Get unique cities
  const uniqueCities = [...new Set(users.map(u => u.city).filter(Boolean))].sort();

  return (
    <div className="container mt-4" style={{ position: "relative" }}>

      {/* 🔒 Payment Verification Overlay */}
      {currentUser.payment_status == 0 && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div className="text-center text-white p-4">
            <h3 className="mb-3">Payment Verification Required</h3>
            <p>Please verify your payment in Profile.</p>
          </div>
        </div>
      )}

      <h3 className="mb-4 text-center fw-bold">Find Your Match 💍</h3>

      {/* ================= FILTER SECTION ================= */}
      <div className="card shadow-sm p-3 mb-4">
        <div className="row">

          <div className="col-md-3 mb-2">
            <select
              className="form-select"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">Looking For</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          <div className="col-md-3 mb-2">
            <select
              className="form-select"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            >
              <option value="">Select City</option>
              {uniqueCities.map((cityName) => (
                <option key={cityName} value={cityName}>
                  {cityName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mb-2">
            <input
              type="number"
              placeholder="Min Age"
              className="form-control"
              value={minAge}
              onChange={(e) => setMinAge(e.target.value)}
            />
          </div>

          <div className="col-md-3 mb-2">
            <input
              type="text"
              placeholder="Search by Qualification"
              className="form-control"
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
            />
          </div>

          <div className="col-md-12 mb-2">
            <input
              type="text"
              placeholder="Search by profession, qualification, about..."
              className="form-control"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
          </div>

          <div className="col-md-12 mb-2">
            <button
              className="btn btn-primary w-100"
              onClick={applyFilters}
            >
              Search
            </button>
          </div>

        </div>
      </div>

      {/* ================= USER CARDS ================= */}

      <div className="row">

        {filteredUsers.length === 0 && (
          <p className="text-center text-muted">
            No profiles found.
          </p>
        )}

        {filteredUsers.map((user) => (
          <div key={user.id} className="col-md-6 col-lg-4 mb-4">

            <div className="card shadow-sm border-0 h-100 animate__animated animate__fadeInUp">

              <div className="text-center mt-3">
                <img
                  src={`https://lingayatwelfarekarnataka.com/${user.profile_photo_path}`}
                  alt="Profile"
                  className="rounded-circle shadow"
                  style={{
                    width: "130px",
                    height: "130px",
                    objectFit: "cover",
                    border: "3px solid #0d6efd"
                  }}
                />
              </div>

              <div className="card-body text-center">

                <h5 className="fw-bold">{user.name}</h5>

                <p className="text-muted">
                  {user.age} Years • {user.gender}
                </p>

                <div className="text-start mt-3">

                  <p className="mb-1">
                    <FaMapMarkerAlt className="me-2 text-danger" />
                    {user.city}
                  </p>

                  <p className="mb-1">
                    <FaBirthdayCake className="me-2 text-warning" />
                    {user.date_of_birth}
                  </p>

                  <p className="mb-1">
                    <FaRulerVertical className="me-2 text-info" />
                    {user.height} cm
                  </p>

                  <p className="mb-1">
                    <FaBriefcase className="me-2 text-success" />
                    {user.annual_income}
                  </p>

                  {user.qualification && (
                    <p className="mb-1">
                      <FaBriefcase className="me-2 text-primary" />
                      {user.qualification}
                    </p>
                  )}

                </div>

                <div className="mt-3">
                  <button
                    className={`btn w-100 ${
                      sentInterests.includes(user.id)
                        ? "btn-secondary"
                        : "btn-danger"
                    }`}
                    disabled={sentInterests.includes(user.id)}
                    onClick={() => handleInterested(user.id)}
                  >
                    {sentInterests.includes(user.id)
                      ? "Interest Sent ✅"
                      : "Interested ❤️"}
                  </button>
                </div>

              </div>

            </div>

          </div>
        ))}

      </div>

    </div>
  );
}

export default ViewUsers;
